// src/components/LoginModal.js
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../slices/authSlice";
import { motion } from "framer-motion";

const LoginModal = ({ onClose, onSwitchToRegister }) => {
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.auth);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();
    dispatch(loginUser({ email, password })).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        onClose();
      }
    });
  };

  const openForgotPassword = () => {
    onClose();
    window.dispatchEvent(new CustomEvent("openForgotPassword"));
  };

  return (
    <div
      className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center loginmod"
      style={{ zIndex: 10000 }}
    >
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        className="bg-white rounded-xl shadow-2xl p-6 w-full max-w-sm"
      >
        <h2 className="text-lg font-semibold text-gray-800 mb-4 text-center">
          Login to Foodie
        </h2>

        {error && <p className="text-red-500 text-sm mb-2">{error}</p>}

        <form onSubmit={handleLogin} className="space-y-3">
          <input
            type="email"
            placeholder="Email"
            className="w-full p-2 text-sm border rounded-lg focus:ring-2 focus:ring-black"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <input
            type="password"
            placeholder="Password"
            className="w-full p-2 text-sm border rounded-lg focus:ring-2 focus:ring-black"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          {/* 🔥 Forgot Password */}
          <p
            onClick={openForgotPassword}
            className="text-xs  text-blue-600 cursor-pointer hover:underline"
          >
            Forgot Password?
          </p>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-black text-white text-sm py-2 rounded-lg hover:bg-gray-800 transition"
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>

        <p className="mt-3 text-xs text-center text-gray-600">
          Don’t have an account?{" "}
          <span
            onClick={onSwitchToRegister}
            className="text-black font-medium cursor-pointer hover:underline"
          >
            Register
          </span>
        </p>

        <button
          onClick={onClose}
          className="mt-4 w-full py-2 text-sm rounded-lg bg-gray-200 hover:bg-gray-300 transition"
        >
          Close
        </button>
      </motion.div>
    </div>
  );
};

export default LoginModal;
